"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOldComponentTracking = exports.useComponentTracking = exports.default = exports.TrackingContext = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactGtmModule = _interopRequireDefault(require("react-gtm-module"));

var _Pc = require("@jobmatchme/amplify-tools/es/provider/Pc");

var _appConfig = _interopRequireDefault(require("@jobmatchme/library-utils/es/appConfig"));

var _uuid = require("uuid");

var _getUrlParam = require("@jobmatchme/utils/es/getUrlParam");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SESSION_KEY = 'jmmSession';

var _getSession = function _getSession() {
  var currentSession;

  try {
    var maybeSession = sessionStorage.getItem(SESSION_KEY);

    if (maybeSession) {
      currentSession = JSON.parse(maybeSession);
    }
  } catch (error) {
    console.error(error);
  }

  if (!currentSession) {
    currentSession = {
      uuid: (0, _uuid.v4)(),
      urlParams: (0, _getUrlParam.getUrlVars)()
    };

    try {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(currentSession));
    } catch (error) {
      console.error(error);
    }
  }

  return currentSession;
};

var _track = function _track(trackingPayload) {
  var eventName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'trackSession';
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var session = _getSession();

  var payload = (0, _extends2.default)({
    session: session
  }, trackingPayload, {
    location: window.location.href,
    referrer: document.referrer
  });

  if (navigator.userAgent !== 'ReactSnap') {
    var _trackingPayload = {
      eventName: eventName,
      timestamp: Date.now(),
      payload: payload
    };

    if (!options.noInternal) {
      if (typeof navigator.sendBeacon === 'function') {
        navigator.sendBeacon("".concat(_appConfig.default.routes.comApi, "/trackingService/create"), JSON.stringify(_trackingPayload));
      } else {
        fetch("".concat(_appConfig.default.routes.comApi, "/trackingService/create"), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            Accept: 'application/json'
          },
          body: JSON.stringify(_trackingPayload)
        });
      }
    }

    if (!options.noGtm) {
      var tagManagerArgs = {
        dataLayer: (0, _extends2.default)({}, payload, {
          event: payload.tagEvent ? payload.tagEvent : payload.event
        }),
        dataLayerName: 'PageDataLayer'
      };

      _reactGtmModule.default.dataLayer(tagManagerArgs);
    }
  }
};

var _updateSession = function _updateSession(key, value, didChange, event) {
  var currentSession = _getSession();

  if (didChange && !didChange(currentSession[key], value)) {
    return;
  }

  var newSession = (0, _extends2.default)({}, currentSession);
  newSession[key] = value;

  _track({
    event: event || 'updateSession',
    updatedKey: key,
    session: newSession
  });

  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(newSession));
  } catch (error) {
    console.error(error);
  }
};

var _updateAuth = function _updateAuth(isAuthenticated, user) {
  var _user$attributes, _user$attributes2;

  var jmmDomain = new RegExp('@jobmatch.me$');
  var isJmm = jmmDomain.test(user === null || user === void 0 ? void 0 : (_user$attributes = user.attributes) === null || _user$attributes === void 0 ? void 0 : _user$attributes.email);

  if (isJmm && window.location.hostname.split('.').slice(-2).join('.') === 'jobmatch.me') {
    document.cookie = '__hs_do_not_track=yes; max-age=15811200; domain=.jobmatch.me; path=/';
    document.cookie = '__hs_opt_out=yes; max-age=15811200; domain=.jobmatch.me; path=/';
  }

  var bcId = user === null || user === void 0 ? void 0 : (_user$attributes2 = user.attributes) === null || _user$attributes2 === void 0 ? void 0 : _user$attributes2['custom:UUID'];

  _updateSession('authentication', {
    isAuthenticated: isAuthenticated,
    username: user === null || user === void 0 ? void 0 : user.username,
    isJmm: isJmm,
    bcId: bcId
  }, function (oldAuthentication, newAuthentication) {
    return !!(oldAuthentication !== null && oldAuthentication !== void 0 && oldAuthentication.isAuthenticated) !== !!newAuthentication.isAuthenticated;
  }, 'updateAuth');
};

var TrackingContext = /*#__PURE__*/_react.default.createContext({
  track: function track() {},
  track2: function track2() {},
  trackPage: function trackPage() {},
  trackEvent: function trackEvent() {},
  trackIt: function trackIt() {},
  trackRegistration: function trackRegistration() {},
  getSession: function getSession() {
    return {};
  },
  updateSession: function updateSession() {}
});

exports.TrackingContext = TrackingContext;

var TrackingProvider = function TrackingProvider(_ref) {
  var children = _ref.children,
      _ref$AuthContext = _ref.AuthContext,
      AuthContext = _ref$AuthContext === void 0 ? _Pc.Context : _ref$AuthContext,
      _ref$app = _ref.app,
      app = _ref$app === void 0 ? 'unknownApp' : _ref$app,
      appData = _ref.appData;

  var _useContext = (0, _react.useContext)(AuthContext),
      isAuthenticated = _useContext.isAuthenticated,
      user = _useContext.user;

  (0, _react.useEffect)(function () {
    _updateAuth(isAuthenticated, user);
  }, [isAuthenticated, user]);
  var track = (0, _react.useCallback)(function (page, data) {
    _track((0, _extends2.default)({}, appData ? appData : {}, {
      app: app,
      event: 'trackPage',
      page: page,
      data: data,
      type: 'track'
    }));
  }, [app, appData]);
  var track2 = (0, _react.useCallback)(function (componentData, event, data) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _track((0, _extends2.default)({}, appData ? appData : {}, {
      app: app
    }, componentData, {
      event: event,
      type: 'trackEvent',
      data: data
    }), 'trackSession', options);
  }, [app, appData]);
  var trackPage = (0, _react.useCallback)(function (componentData, page, data) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _track((0, _extends2.default)({}, appData ? appData : {}, {
      app: app
    }, componentData, {
      event: 'trackPage',
      type: 'trackPage',
      page: page,
      data: data
    }), 'trackSession', options);
  }, [app, appData]);
  var trackEvent = (0, _react.useCallback)(function (componentData, _ref2) {
    var eventName = _ref2.eventName,
        payload = _ref2.payload;

    _track((0, _extends2.default)({}, appData ? appData : {}, {
      app: app
    }, componentData, {
      type: 'methodTrackEvent'
    }, payload), eventName);
  }, [app, appData]);
  var trackIt = (0, _react.useCallback)(function (componentData, url, name, title) {
    var method = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'methodTrackIt';

    _track((0, _extends2.default)({}, appData ? appData : {}, {
      app: app
    }, componentData, {
      type: method,
      url: url,
      name: name,
      title: title,
      page: url,
      tagEvent: name,
      pageTitle: title
    }));
  }, [app, appData]);
  var trackRegistration = (0, _react.useCallback)(function (componentData, type) {
    trackIt(componentData, "/registration/completed".concat(type ? '/' + type : ''), 'Registration', window.location.href.includes('/pflege/') ? 'pflege' : 'truck Registration ' + type, 'methodTrackRegistration');
  }, [trackIt]);
  var tracking = (0, _react.useMemo)(function () {
    return {
      track: track,
      track2: track2,
      trackPage: trackPage,
      trackEvent: trackEvent,
      trackIt: trackIt,
      trackRegistration: trackRegistration,
      getSession: _getSession,
      updateSession: _updateSession
    };
  }, [track, track2, trackPage, trackEvent, trackIt, trackRegistration]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(TrackingContext.Provider, {
    value: tracking,
    children: children
  });
};

var _default = TrackingProvider;
exports.default = _default;

var useOldComponentTracking = function useOldComponentTracking(component, componentData) {
  var tracking = (0, _react.useContext)(TrackingContext);
  var track = (0, _react.useCallback)(function (event, data) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    tracking.track2(componentData ? (0, _extends2.default)({}, componentData, {
      component: component
    }) : {
      component: component
    }, event, data, options);
  }, [component, componentData, tracking]);
  var trackPage = (0, _react.useCallback)(function (page, data) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    tracking.trackPage(componentData ? (0, _extends2.default)({}, componentData, {
      component: component
    }) : {
      component: component
    }, page, data, options);
  }, [component, componentData, tracking]);
  var trackEvent = (0, _react.useCallback)(function (_ref3) {
    var eventName = _ref3.eventName,
        payload = _ref3.payload;
    tracking.trackEvent(componentData ? (0, _extends2.default)({}, componentData, {
      component: component
    }) : {
      component: component
    }, {
      eventName: eventName,
      payload: payload
    });
  }, [component, componentData, tracking]);
  var trackIt = (0, _react.useCallback)(function (url, name, title) {
    var method = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'methodTrackIt';
    tracking.trackIt(componentData ? (0, _extends2.default)({}, componentData, {
      component: component
    }) : {
      component: component
    }, url, name, title, method);
  }, [component, componentData, tracking]);
  var trackRegistration = (0, _react.useCallback)(function (type) {
    tracking.trackRegistration(componentData ? (0, _extends2.default)({}, componentData, {
      component: component
    }) : {
      component: component
    }, type);
  }, [component, componentData, tracking]);
  var componentTracking = (0, _react.useMemo)(function () {
    return {
      track: track,
      trackPage: trackPage,
      trackEvent: trackEvent,
      trackIt: trackIt,
      trackRegistration: trackRegistration,
      getSession: tracking.getSession,
      updateSession: tracking.updateSession
    };
  }, [track, trackPage, trackEvent, trackIt, trackRegistration, tracking]);
  return componentTracking;
};

exports.useOldComponentTracking = useOldComponentTracking;

var useComponentTracking = function useComponentTracking(component, componentData) {
  var tracking = (0, _react.useContext)(TrackingContext);
  var track = (0, _react.useCallback)(function (event, data) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    tracking.track2(componentData ? (0, _extends2.default)({}, componentData, {
      component: component
    }) : {
      component: component
    }, event, data, options);
  }, [component, componentData, tracking]);
  var componentTracking = (0, _react.useMemo)(function () {
    return {
      track: track,
      getSession: tracking.getSession,
      updateSession: tracking.updateSession
    };
  }, [track, tracking]);
  return componentTracking;
};

exports.useComponentTracking = useComponentTracking;